export const responseQuery = `
    query EphemeralJobResult($id: ID!) {
      ephemeralJobResult(id: $id) {
        state
        value
      }
    }
  `

export const asyncRpcQuery = `
  mutation AsyncRpc(
    $service: String!,
    $method: String!,
    $params: JSON,
  ) {
    asyncRpc(input: {
      service: $service,
      method: $method,
      params: $params
    }) {
      jobId
    }
  }
`
